module.exports = __webpack_public_path__ + "static/img/NO.5314cfae.svg";